<template>
    <div>
        <div name="query-sort-block">
            <swb-query-sort-area ref="query_model_ctrl" :confKey="confKey" :configAuto="true" :queryOnLoad="queryOnLoad" :onConfigReady="onQueryConfigReady" :queryHandler="queryHandler"></swb-query-sort-area>
        </div>
        <swb-result-table name="result_table" :btnColBaseCount="2" :btnColMoreTitle="'更多操作'" ref="result_table" :confKey="confKey" :configAuto="true" :needPager="needPager" :multiSelect="multiSelect"
                          :multiPageSelect="multiPageSelect" :rowKeyPropName="rowKeyPropName" :rowNoShow="rowNoShow" :rowNoFixed="rowNoFixed" :btnColName="btnColName" :btnColTitle="btnColTitle" :btnColWidth="btnColWidth"
                          :btnColFixed="btnColFixed" :height="theTableHeight" :pageNoChangeHandler="pageNoChangeHandler" :rowDblClickHandler="rowDblClickHandler"></swb-result-table>
    </div>
</template>

<script>
    import {Utils, $} from '../../app.base'
    import {Vue, MsgBox, DomSizeWatcher, Routes} from '../../app.vues'

    import {checkUserActionPerm} from '../index'
    import {getDefaultPageSizes} from '../../app.conf'
    import {openBizPermScopeDlg} from './selectDlg'

    import userApi from '../../api/user';
    import merchtAllApi from '../../api/merchtAll'

    import SwbMerchtBizPermScopeSave from './MerchtBizPermScopeSave';
    Vue.regist(SwbMerchtBizPermScopeSave);

    import SwbMerchtBizPermScopeBusinessSet from './MerchtBizPermScopeBusinessSet';
    Vue.regist(SwbMerchtBizPermScopeBusinessSet);

    export default {
        name: 'swb-mercht-biz-perm-scope-list-select',
        desc: '商户业务权限范围',
        props: {
            filter: {
                type: Object,
                default: function () {
                    return {};
                }
            }
        },
        data: function () {
            return {
                confKey: "swb-mercht-biz-perm-scope-list-select",
                queryOnLoad: true,
                // 分页信息
                theTableHeight: 500,
                //
                needPager: true, //是否需要分页（默认：true）
                multiSelect: false, //是否多选（默认：false）
                multiPageSelect: false, //是否要多页/跨页选择（默认：false）
                rowKeyPropName: "id", //记录数据关键标识列名（多页/跨页选择必须，默认: id）
                rowNoShow: true, //是否显示行号（默认：true）
                rowNoFixed: true, //行号列是否固定（默认：false）

                btnColName: 'actions',//操作列名称（如果不设置就不显示操作列）
                //
                btnColTitle: '操作',//操作列标题（默认：'操作'）
                btnColWidth: 100,//操作列宽度（默认：100）
                //
                btnColFixed: true, //操作列是否固定
                //
                pageSize: getDefaultPageSizes().first(),
                pageNumber: 1,
                // 过滤信息
                queryKey: null,
                queryModel: {
                    filterItems: {},
                    sortItemList: [],
                    sortItems: {}
                },
                // 其他信息
                scopeEntity: null
            }
        },
        created: function () {
            this.getCurrUserInfo();
        },
        mounted() {
            let self = this;
            //注册domSizeWatcher
            let thisEl = $(this.$el);
            $(this.$el).addClass('overflow-hidden');
            //
            let domSizeWatcher = this.domSizeWatcher = new DomSizeWatcher(Vue.$getClassInfo(this).name);
            domSizeWatcher.setBaseEl(thisEl);
            domSizeWatcher.setMainEl(thisEl.find('[name="result_table"]'), function (width, height, theEl) {
                //根据新主元素的内容大小，调整表格高度
                self.theTableHeight = height;

            });
            //domSizeWatcher.setHrEls();
            domSizeWatcher.setVtEls(thisEl.find('[name="query-sort-block"], .simple-row'));
            domSizeWatcher.start(500);
            //
            this.initResultTable();
        },
        destroyed() {
            //释放domSizeWatcher
            let domSizeWatcher = this.domSizeWatcher;
            if (domSizeWatcher != null) {
                domSizeWatcher.clear();
                this.domSizeWatcher = null;
            }
        },
        methods: {
            getCurrUserInfo(){
                let self = this;
                userApi.getUserInfoByContext({}, function (result) {
                    if (result.type == 'info') {
                        self.scopeEntity = result.data.scopeEntity;
                    }
                });
            },
            onQueryConfigReady: function (event) {
                //
            },
            initResultTable() {
                let self = this;
                let query_model_ctrl = this.$refs['query_model_ctrl'];
                let resultTable = this.$refs['result_table'];
                //关联[查询排序对象]到结果表格（结果表格可以实时利用最新的 列配置 和 排序信息，同时结果表格列宽也会反向同步到其中的[列配置对象]中去）
                resultTable.setQrySortRef(query_model_ctrl);
                //
                resultTable.initMeta(/* confColList, */ /* 单元格html渲染函数 */{
                    'comLevel': function (row, colName, colValue, rowIndex, colConf) {
                        if (!row.shopFlag) {
                            if (row.comLevel1) {
                                return '一级业务单元';
                            } else if (row.comLevel2) {
                                return '二级业务单元';
                            } else if (row.comLevel3) {
                                return '三级业务单元';
                            } else if (row.comLevel4) {
                                return '四级业务单元';
                            }
                        }
                    },
                    'bizPermOrgFlag': function (row, colName, colValue, rowIndex, colConf) {
                        if (row.bizPermFlag) {
                            if (row.bizPermOrgFlag == 1) {
                                return '仅本机构';
                            } else if (row.bizPermOrgFlag == 3) {
                                return '本机构及以下';
                            }
                        }
                    },
                    'actions': function (row, colName, colValue, rowIndex) {
                        let btnList = [];
                        btnList.push({
                            name: 'biz_scope',
                            text: '数据范围'
                        });
                        return btnList;
                    }
                }, /* 单元格按钮点击处理函数 */{
                    //*代表可处理未指定事件函数的任意列的按钮/链接的点击
                    'actions': function (row, colName, colValue, rowIndex, btnName) {
                        if (btnName == "biz_scope") {
                            self.showBusinessSetDlg(row)
                        }
                    }
                });
            },
            renderTable(rows, pagination) {
                let resultTable = this.$refs.result_table;
                let tableData = {
                    rows: rows,
                    pagination: pagination
                };
                resultTable.render(tableData);
            },
            // 单元格点击事件
            rowDblClickHandler: function (row) {
                if (!this.multiSelect) {
                    console.log("----- 双击数据行 ----");
                    console.log(row);
                }
            },
            getTableSelection() {
                let resultTable = this.$refs.result_table;
                return resultTable.getSelection();
            },
            checkActionPerm: function (action) {
                return checkUserActionPerm(Vue.$getClassInfo(this).path, action, null);
            },
            pageNoChangeHandler: function (pageNumber, pageSize) {
                console.log("分页 => 第【" + pageNumber + "】页，大小：" + pageSize);
                //
                this.pageSize = pageSize;
                this.pageNumber = pageNumber;
                //
                this.getDataList();
            },
            queryHandler: function (queryModel) {
                this.queryModel = queryModel;
                this.pageNumber = 1;
                this.getDataList();
            },
            getDataList(){
                let self = this;
                let postData = {};
                postData.pagination = {
                    pageSize: self.pageSize,
                    pageNumber: self.pageNumber,
                };
                //
                let queryModel = self.queryModel;
                let filterItems = Utils.merge({}, queryModel.filterItems);
                let sortItemList = Utils.merge([], queryModel.sortItemList);
                let sortItems = Utils.merge({}, queryModel.sortItems);
                //
                filterItems.disabled = false;
                filterItems = Utils.merge(this.filter, filterItems);
                //
                postData.filterItems = filterItems;
                postData.sortItemList = sortItemList;
                postData.sortItems = sortItems;
                //
                let theLoading = MsgBox.loading();
                merchtAllApi.getMerchtBizPermScopeList(postData, function (result) {
                    theLoading.close();
                    if (result.type == 'info') {
                        //
                        self.renderTable(result.data.rows, result.data.pagination);
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            showBusinessSetDlg(row){
                openBizPermScopeDlg(row.id, true, function () {

                });
            },
            getDlgResult() {
                let selection = this.getTableSelection();
                let result = {};
                if (selection == null) {
                    result.type = 'warn';
                    result.message = "请选择！";
                } else {
                    result.type = 'info';
                    result.data = selection;
                }
                return result;
            },
        }
    }
</script>



// WEBPACK FOOTER //
// src/compo/authx/MerchtBizPermScopeListSelect.vue